export default __webpack_public_path__ + "static/media/bklogo.60ace254.png";